import styled from 'styled-components';
import { renderStyledElementStyles, devices } from '../../../../helpers';

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  @media (min-width: ${devices.breakpoints.tablet}) {
    margin-top: 0;
  }

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.column)}

  ${({ theme, index }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.column.settings?.[index],
    )}
  
  h3 {
    ${({ theme, index }) =>
      renderStyledElementStyles(
        theme,
        theme.module.dStyles.elements.column.settings?.title?.[index],
      )}
  }
`;

export const Title = styled.h3`
  line-height: 1;
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.column.elements.title,
    )}

  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.column.elements.title,
    )}
`;
